<div class="country-picker-container">
    <div class="country-input-group">
        <div class="country-input-wrapper">
            <!-- Selected Country Display -->
            @if (selectedCountry) {
            <div class="selected-country" (click)="toggleDropdown()">
                @if (showFlag && selectedCountry.icon) {
                <img [src]="selectedCountry.icon" [alt]="selectedCountry.name" class="country-flag" />
                }
                <span class="country-text">{{ getCountryDisplay(selectedCountry) }}</span>
                <span class="dropdown-arrow" [class.open]="isOpen">▼</span>
            </div>
            } @else {
            <div class="selected-country placeholder" (click)="toggleDropdown()">
                <span class="country-text">{{ placeholder }}</span>
                <span class="dropdown-arrow" [class.open]="isOpen">▼</span>
            </div>
            }

            <!-- Search Input (Shown when dropdown is open) -->
            @if (isOpen) {
            <div class="search-overlay">
                <input type="text" class="country-search-input" [placeholder]="placeholder"
                    (input)="onSearchChange($event)" (keyup)="$event.stopPropagation()" />
            </div>
            }
        </div>

        <!-- Filtered Countries Dropdown -->
        @if (isOpen) {
        <div class="countries-dropdown" (click)="$event.stopPropagation()">
            @if (filteredCountries.length > 0) {
            <div class="countries-list">
                @for (country of filteredCountries; track trackByCode($index, country)) {
                <div class="country-option" (click)="selectCountry(country)"
                    [class.active]="selectedCountry?.code === country.code">
                    <div class="country-option-content">
                        @if (showFlag && country.icon) {
                        <img [src]="country.icon" [alt]="country.name" class="country-flag-small" />
                        }
                        <div class="country-info">
                            <span class="country-name">{{ country.name }}</span>
                            <span class="country-code">{{ country.country_code }}</span>
                        </div>
                    </div>
                </div>
                }
            </div>
            } @else if (countries.length === 0) {
            <div class="no-results">Loading countries...</div>
            } @else {
            <div class="no-results">No countries found</div>
            }
        </div>

        <!-- Backdrop to close dropdown when clicking outside -->
        <div class="dropdown-backdrop" (click)="closeDropdown()"></div>
        }
    </div>
</div>